<template>
  <div class="promotionsList">
    <div class="row">

      <div class="col-md-12">
        <h1 class="titulo">{{ title }}</h1>
      </div>

      <div class="col-md-12">
        <div class="evento_detalhes">
          <img class="capa" v-if="item.image" :src="item.image"/>
          <img class="capa" v-if="!item.image" src="dist/images/sem_imagem.jpg"/>


          <div class="descricao">
            <h3>Sobre o evento</h3>
            <span>
              <i aria-hidden="true" class="fa fa-calendar"></i> Início: {{ item.dateInit }}
              <i aria-hidden="true" class="fa fa-clock-o"></i> {{ item.hourInit }}
            </span>
            <span>
                <i aria-hidden="true" class="fa fa-calendar"></i> Fim: {{ item.dateFinish }}
                <i aria-hidden="true" class="fa fa-clock-o"></i> {{ item.hourFinish }}
            </span>
            <span>
              <i aria-hidden="true" class="fa fa-map-marker"></i> Local: {{ item.local }}
            </span>
          </div>

          <div class="texto" v-html="item.description"></div>


          <div class="socialShare">
            <social-sharing :url="currentUrl" inline-template>
              <div>
                <span> Clique e compartilhe: </span>
                <network network="facebook">
                  <i class="fab fa-facebook-f" aria-hidden="true"></i>
                </network>
                <network network="googleplus">
                  <i class="fab fa-google-plus-g" aria-hidden="true"></i>
                </network>
                <network network="twitter">
                  <i class="fab fa-twitter" aria-hidden="true"></i>
                </network>
              </div>
            </social-sharing>
          </div>
        </div>


      </div>


    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import SocialSharing from 'vue-social-sharing';


  export default {
    components: {
      Loading,
      SocialSharing
    },
    data() {
      return {
        title: 'Evento',
        showContent: false,
        item: [],
        currentUrl: ''
      }
    },
    activated() {
      let self = this;
      self.showContent = false;
      get('event/' + this.$route.params.id).then(function (response) {
        self.item = response.data.result.data;
        self.showContent = true;
        self.title = self.item.name;
      });
    },
    created() {
      this.currentUrl = window.location.href;
      let self = this;
      get('event/' + this.$route.params.id).then(function (response) {
        self.item = response.data.result.data;
        self.showContent = true;
        self.title = self.item.name;
      });
    },
    methods: {
      checkShowMap(locale) {
        if (typeof locale === 'undefined') {
          return false;
        }
        return true;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Event.vue